import { NgModule } from '@angular/core';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { MAT_MOMENT_DATE_ADAPTER_OPTIONS, MomentDateAdapter } from '@angular/material-moment-adapter';

import { NK_DATE_DEFAULT_FORMATS } from '../datetime.formats';

import { DateTimeAdapter } from './date-time-adapter';
import { NkMomentDateTimeAdapter } from './moment-date-time-adapter';

@NgModule({
  providers: [
    { provide: MAT_DATE_FORMATS, useValue: NK_DATE_DEFAULT_FORMATS },
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS]
    },
    { provide: DateTimeAdapter, useClass: NkMomentDateTimeAdapter }
  ]
})
export class NkMomentDateTimeModule {}
